var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModifyMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_982_466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3585 3.00435L12.996 4.64104L11.3585 3.00435ZM12.4115 1.56249L7.98385 5.99013C7.75508 6.21859 7.59905 6.50966 7.53544 6.82665L7.12646 8.87386L9.17368 8.46411C9.49066 8.40071 9.78135 8.24532 10.0102 8.01647L14.4378 3.58883C14.5709 3.45578 14.6764 3.29782 14.7484 3.12398C14.8204 2.95014 14.8575 2.76382 14.8575 2.57566C14.8575 2.3875 14.8204 2.20118 14.7484 2.02734C14.6764 1.8535 14.5709 1.69554 14.4378 1.56249C14.3048 1.42944 14.1468 1.3239 13.973 1.25189C13.7991 1.17988 13.6128 1.14282 13.4247 1.14282C13.2365 1.14282 13.0502 1.17988 12.8763 1.25189C12.7025 1.3239 12.5445 1.42944 12.4115 1.56249V1.56249Z",
    stroke: "url(#paint0_linear_982_466)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3111 10.4201V12.7395C13.3111 13.1496 13.1482 13.5429 12.8582 13.8328C12.5683 14.1228 12.175 14.2857 11.7649 14.2857H3.26059C2.8505 14.2857 2.45721 14.1228 2.16724 13.8328C1.87726 13.5429 1.71436 13.1496 1.71436 12.7395V4.2352C1.71436 3.82511 1.87726 3.43182 2.16724 3.14185C2.45721 2.85187 2.8505 2.68896 3.26059 2.68896H5.57994",
    stroke: "url(#paint1_linear_982_466)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_982_466",
    x1: 7.12646,
    y1: 5.00834,
    x2: 14.8575,
    y2: 5.00834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#3154C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_982_466",
    x1: 1.71436,
    y1: 8.48734,
    x2: 13.3111,
    y2: 8.48734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#3154C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_982_466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifyMessage);
export default __webpack_public_path__ + "static/media/modify_message.48a2b2426efb8c04c2c0ae370fc87390.svg";
export { ForwardRef as ReactComponent };